import { Injectable } from '@angular/core';
import { PreferredDealerRequest, PreferredDealer, PreferredDealerResponse } from '../../../api/models/preferred-dealer';
import { WfsDirectAjaxService } from '../wfs-direct-ajax.service';
import { Observable } from 'rxjs/Observable';
import { AutoLoanService } from '../auto-loans/auto-loan.service';


@Injectable()
export class DealersService {

    constructor(
        private wfsDirectAjax: WfsDirectAjaxService,
        private _autoLoanService: AutoLoanService
    ) { }

    getPreferred(filter: PreferredDealerRequest): Observable<PreferredDealer[]> {

        const requestData = {
            request_type: 'preferredDealers',
            dealershipFilter: JSON.stringify(filter)
        };

        return this._autoLoanService.getClosestDealers(requestData)
            .map(response => {
                const dealers: PreferredDealerResponse[] = response.data;
                return dealers.map((dealer: PreferredDealerResponse) => {
                    return {
                        dealerName: dealer.AccountName,
                        dealerPhone: dealer.PrimaryPhone,
                        dealerAddress: dealer.Address,
                        dealerState: dealer.State,
                        dealerCity: dealer.City,
                        dealerZip: dealer.Zip
                    };
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/dealers/dealers.service.ts